import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Switch } from '../../components/ui/switch';
import { toast } from 'sonner';

export function SettingsPage() {
  const [name, setName] = useState('Alex Taylor');
  const [headline, setHeadline] = useState('Product manager exploring returner programmes');
  const [bio, setBio] = useState('');
  const [twoFactor, setTwoFactor] = useState(true);

  const handleSave = () => {
    toast.success('Settings updated.');
  };

  return (
    <main aria-labelledby="account-settings-heading" className="min-h-screen bg-[#070916] pb-24">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
        <header className="space-y-2">
          <h1 id="account-settings-heading" className="text-3xl font-semibold text-white sm:text-4xl">Account settings</h1>
          <p className="text-sm text-gray-400">
            Manage your profile, privacy, and account security. You can request data export or deletion at any time.
          </p>
        </header>

        <div className="mt-10 space-y-6">
          <Card className="border-white/10 bg-white/[0.03]">
            <CardHeader>
              <CardTitle className="text-lg text-white">Profile</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 p-6 pt-0">
              <form className="space-y-4" aria-label="Profile settings">
                <div className="space-y-2">
                  <Label htmlFor="settings-name" className="text-sm text-gray-300">
                    Name
                  </Label>
                  <Input
                    id="settings-name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                    className="border-white/10 bg-white/10 text-white placeholder:text-gray-400"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="settings-headline" className="text-sm text-gray-300">
                    Headline
                  </Label>
                  <Input
                    id="settings-headline"
                    value={headline}
                    onChange={(event) => setHeadline(event.target.value)}
                    className="border-white/10 bg-white/10 text-white placeholder:text-gray-400"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="settings-bio" className="text-sm text-gray-300">
                    Bio
                  </Label>
                  <Textarea
                    id="settings-bio"
                    rows={4}
                    value={bio}
                    onChange={(event) => setBio(event.target.value)}
                    placeholder="Optional short story about your career journey."
                    className="border-white/10 bg-white/10 text-white placeholder:text-gray-400"
                  />
                </div>
              </form>
            </CardContent>
          </Card>

          <Card className="border-white/10 bg-white/[0.03]">
            <CardHeader>
              <CardTitle className="text-lg text-white">Privacy & data</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 p-6 pt-0 text-sm text-gray-300">
              <p>
                Lighthouse lets you export your data or request deletion (with reversible cooling-off period). We also blur PII in moderated views.
              </p>
              <div className="flex flex-wrap gap-3" role="group" aria-label="Privacy actions">
                <Button type="button" variant="outline" className="border-white/20 text-white hover:bg-white/10">
                  Request data export
                </Button>
                <Button type="button" variant="ghost" className="text-red-300 hover:text-red-200">
                  Request account deletion
                </Button>
              </div>
            </CardContent>
          </Card>

          <Card className="border-white/10 bg-white/[0.03]">
            <CardHeader>
              <CardTitle className="text-lg text-white">Security</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 p-6 pt-0">
              <div className="flex items-center justify-between rounded-xl border border-white/10 bg-white/[0.04] p-4">
                <div>
                  <p className="text-sm font-medium text-white">Two-factor authentication</p>
                  <p className="text-xs text-gray-400">
                    Required for employer admins. Candidates can enable for extra protection.
                  </p>
                </div>
                <Switch checked={twoFactor} onCheckedChange={(checked) => setTwoFactor(Boolean(checked))} aria-label="Toggle two-factor authentication" />
              </div>
              <Button type="button" variant="outline" className="border-white/20 text-white hover:bg-white/10">
                Reset password
              </Button>
            </CardContent>
          </Card>

          <div className="flex justify-end">
            <Button type="button" onClick={handleSave} className="bg-gold-gradient text-black hover:brightness-110">
              Save changes
            </Button>
          </div>
        </div>
      </div>
    </main>
  );
}
